import { Portal } from "shared/ui/Portal";
import styles from "./AppRenderErrorModal.module.scss";

export const AppRenderErrorModal = ({ message }: { message: string }) => {
  return (
    <Portal className={styles.modal}>
      <p className={styles.text}>{message}</p>
    </Portal>
  );
};
